document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".grind-type-btn");

  buttons.forEach(button => {
    button.addEventListener("click", () => {
        const elem = document.getElementById("grindTypeInpt");
        const grindTypeField = document.getElementById("grindTypeField");
      // remove active class from all buttons
      buttons.forEach(btn => btn.classList.remove("active"));
      
      // add active class to clicked button
      button.classList.add("active");

      // handle selected value
      const selectedValue = button.dataset.value;
      console.log("Selected option:", selectedValue);
      elem.value = selectedValue;
      grindTypeField.value = selectedValue;

      // 👉 You can add custom logic here
    });
  });
});
